<template>
    <div v-if="maintenanceStore.isVisible" class="maintenance-banner">
        <el-alert :type="alertType"
                  :title="text"
                  :closable="closable"
                  show-icon
                  @close="maintenanceStore.dismiss()" />
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import {
        useMaintenanceStore,
        formatMaintenanceDate,
        formatMaintenanceTime,
        formatMaintenanceEnd
    } from '@/stores/maintenanceStore';

    export default defineComponent({
        data() {
            return {
                maintenanceStore: useMaintenanceStore(),
            };
        },

        computed: {
            isActive(): boolean {
                return this.maintenanceStore.state === 'active';
            },
            alertType(): 'warning' | 'error' {
                return this.isActive ? 'error' : 'warning';
            },
            closable(): boolean {
                return !this.isActive;
            },
            text(): string {
                const notice = this.maintenanceStore.notice;
                if (notice == null || notice.startUtc == null || notice.endUtc == null) {
                    return '';
                }

                if (notice.message) {
                    return notice.message;
                }

                const locale = this.$i18n.locale;
                const end = formatMaintenanceEnd(notice.startUtc, notice.endUtc, locale);

                if (this.isActive) {
                    return this.$t('maintenance.active', { end });
                }

                return this.$t('maintenance.upcoming', {
                    date: formatMaintenanceDate(notice.startUtc, locale),
                    start: formatMaintenanceTime(notice.startUtc, locale),
                    end
                });
            },
        },

        mounted() {
            this.maintenanceStore.start(this.$i18n.locale);
        },
    })
</script>

<style lang="scss" scoped>
    .maintenance-banner {
        width: 100%;

        .el-alert {
            border-radius: 0;
            justify-content: center;
        }
    }
</style>
